import url from './url';

import { ENV } from '@/configs/env';

export const getH5ocrBaseUrl = () => {
    let BASE_URL =
        'https://dsim476-api.intra.xiaojukeji.com/freya/landing-page/';

    // 正式环境
    if (process.env.BUILD_ENV === ENV.ONLINE) {
        if (/didifinance\.com/.test(window.location.host)) {
            BASE_URL = 'https://fintech-app.didifinance.com/freya/landing-page/';
        } else {
            BASE_URL = 'https://manhattan-app.didiglobal.com/freya/landing-page/';
        }
    }

    // 预发环境
    if (process.env.BUILD_ENV === ENV.PRE) {
        if (/didifinance\.com/.test(window.location.host)) {
            BASE_URL = 'https://fintech-pre.intra.didifinance.com/freya/landing-page/';
        } else {
            BASE_URL = 'http://pre.global.manhattan.app.intra.xiaojukeji.com/freya/landing-page/';
        }
    }

    // sim环境
    if (process.env.BUILD_ENV === ENV.SIM) {
        if (/didifinance\.com/.test(window.location.host)) {
            BASE_URL = 'https://fintech-app.didifinance.com/freya/landing-page/';
        } else {
            BASE_URL = `${window.location.origin.replace('page', 'api')}/freya/landing-page/`;
        }
    }

    return BASE_URL;
};

export const getH5cashloanBaseUrl = () => {
    let BASE_URL =
        'https://dsim566-api.intra.xiaojukeji.com/freya?openCashLoanAutoProgress=1&isNeedPush=1';

    // 正式环境
    if (process.env.BUILD_ENV === ENV.ONLINE) {
        if (/didifinance\.com/.test(window.location.host)) {
            BASE_URL = 'https://fintech-app.didifinance.com/freya?openCashLoanAutoProgress=1&isNeedPush=1';
        } else {
            BASE_URL = 'https://manhattan-app.didiglobal.com/freya?openCashLoanAutoProgress=1&isNeedPush=1';
        }
    }

    // 预发环境
    if (process.env.BUILD_ENV === ENV.PRE) {
        if (/didifinance\.com/.test(window.location.host)) {
            BASE_URL = 'https://fintech-pre.intra.didifinance.com/freya?openCashLoanAutoProgress=1&isNeedPush=1';
        } else {
            BASE_URL = 'http://pre.global.manhattan.app.intra.xiaojukeji.com/freya?openCashLoanAutoProgress=1&isNeedPush=1';
        }
    }

    // sim环境
    if (process.env.BUILD_ENV === ENV.SIM) {
        if (/didifinance\.com/.test(window.location.host)) {
            BASE_URL = 'https://fintech-app.didifinance.com/freya?openCashLoanAutoProgress=1&isNeedPush=1';
        } else {
            BASE_URL = `${window.location.origin.replace('page', 'api')}/freya?openCashLoanAutoProgress=1&isNeedPush=1`;
        }
    }

    return BASE_URL;
};

const getH5OcrUrl = (data?: Record<string, string | number>) => {
    const baseUrl = getH5ocrBaseUrl();
    const resource = url.get('resource') || window.adv?.getChannelEnv();
    const parseQuery = url.parseQuery();
    const urlQuery = {
        ...parseQuery,
        resource,
        fromPage: 'web2app',
        ...data,
    };

    // 生成url
    const queryString = Object.entries(urlQuery)
        .filter(([_, value]) => value !== undefined && value !== null && String(value) !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
        .join('&');

    return `${baseUrl}?${queryString}#/register`;
};

export default getH5OcrUrl;
